<template>
  <div>
    <v-container
      grid-list-md
      text-xs-center
    >
      <!-- <v-layout
        justify-center
        align-center
        fluid
      >
        <v-flex
          xs6
          md6
          :pa-5="$vuetify.breakpoint.smAndDown"
          wrap
        > -->
      <v-layout
        row
        wrap
        justify-center
        align-center
      >
        <v-flex xs12>
          <v-img
            src="/static/nbtools.svg"
            :style="{left: '50%', transform:'translateX(-50%)'}"
          />
        </v-flex>
        <v-flex xs12>
          <v-layout justify-center>
            <div class="v-card__actions">
              <button
                type="button"
                class="px-5 v-btn theme--light primary"
                @click="learnMore"
              >
                <div class="v-btn__content">
                  Take Contact!
                </div>
              </button>
            </div>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<style scoped>
  span.important {font-weight:bold; color:#ec8000;}
  v-btn.mt-4 {background-color:#ec8000 !important;}
</style>

<script>
  import router from '../router'
  export default {
    metaInfo: {
      title: 'nbinfo.eu',
      meta: [
        { name: 'description', content: 'Customized vue-cli templates for nbinfo.eu' }
      ]
    },

    data: () => ({
      items: ['/static/home-parallax.png']
    }),

    computed: {
      cardFeatures () {
        return this.$t('Home.cardFeatures')
      },
      testimonials () {
        return this.$t('Home.testimonials')
      }
    },
    methods: {
      learnMore: function () {
        router.push({ path: '/contact' })
      }
    }

  }
</script>
